import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons"
import logo_url from "../assets/images/logo.webp";

export const profileData = {
   name: "Традиционные ценности",
   name_line1: "Традиционные",
   name_line2: "Ценности",
   logo: logo_url,
   marketplace: [{
      id: 1,
      name: "Ozon",
      url: "https://ozon.ru",
      promo_text: `Наши товары доступны на Ozon`
   }],
   email: "info@example.com",
   rights_reserved: {
      line1: "© 2025 Socks Store",
      comma: ", ",
      line2: "Все права защищены"
   },
   whereToBuy: {
      text: "Наши товары можно приобрести только на",
      location: {
         text: "Ozon",
         url: "https://www.ozon.ru/seller/traditsionnye-tsennosti-1309283"
      }
   },
}

export const burgerMenuData = { faBars: faBars, faXmark: faXmark }

export const linksData = [
   {
      id: 1,
      url: "/",
      name: "Главная"
   }
]

